module.exports = __webpack_public_path__ + "static/media/China-day.a48b5000.svg";